import { Switch } from '@shape-ds/components';
import { Controller, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const NotificationSwitch = <T extends FieldValues>({
  name,
  disabled,
  defaultValue,
  showLabel,
}: {
  name: Path<T>;
  disabled?: boolean;
  defaultValue?: boolean;
  showLabel?: boolean;
}) => {
  const { t } = useTranslation();
  if (disabled) {
    return (
      <div className="notification-switch">
        <span className={`MuiFormControlLabel-label ${defaultValue ? 'on' : 'off'}`}>
          {defaultValue
            ? t(`components:notifications.form.labels.switchOn`)
            : t(`components:notifications.form.labels.switchOff`)}
        </span>
      </div>
    );
  }
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => {
        const formattedValue = disabled ? defaultValue : value ?? false;

        return (
          <div className="notification-switch">
            {showLabel && <span>{t(`components:notifications.form.labels.${name}`)}</span>}
            <Switch
              onChange={(_e, checked) => onChange(checked)}
              checked={formattedValue}
              disabled={disabled}
              label={
                formattedValue
                  ? t(`components:notifications.form.labels.switchOn`)
                  : t(`components:notifications.form.labels.switchOff`)
              }
              labelPosition="end"
            />
          </div>
        );
      }}
    />
  );
};
